module.exports = __webpack_public_path__ + "static/media/16IT221.e5dc01f4.jpg";